export default __webpack_public_path__ + "static/media/router.7ba455fd.png";